import { IconeCorbeille, IconeCrayon } from '../pages/BoutonIcone';
import '../assets/styles/Listes.css';

/**
 * Les deux icônes de fin de ligne, communes à toutes les listes : modifier
 * (crayon) et supprimer (corbeille). Le libellé va dans `title` et
 * `aria-label` : l'icône seule ne dit rien à un lecteur d'écran.
 *
 * Un bouton sans gestionnaire n'est pas rendu ; un bouton `disabled` reste
 * visible, avec son `title` qui dit pourquoi.
 */
function ActionsLigne({
  onModifier,
  onSupprimer,
  modifierTitre = 'Modifier',
  supprimerTitre = 'Supprimer',
  modifierDisabled = false,
  supprimerDisabled = false,
}) {
  return (
    <span className="ligne-icones" onClick={(e) => e.stopPropagation()}>
      {onModifier && (
        <button
          type="button"
          className="ligne-icone-btn"
          onClick={onModifier}
          disabled={modifierDisabled}
          title={modifierTitre}
          aria-label={modifierTitre}
        >
          <IconeCrayon />
        </button>
      )}
      {onSupprimer && (
        <button
          type="button"
          className="ligne-icone-btn ligne-icone-btn-danger"
          onClick={onSupprimer}
          disabled={supprimerDisabled}
          title={supprimerTitre}
          aria-label={supprimerTitre}
        >
          <IconeCorbeille />
        </button>
      )}
    </span>
  );
}

export default ActionsLigne;
